import { ApiService } from './ApiService';

export const ApiArticle = {
  articleList: (search?: string, take?: number, page?: number, startDate?: string, endDate?: string) => `${ApiService.article}?search=${search}&take=${take}&page=${page}&startDate=${startDate}&endDate=${endDate}`,
  articleDetail: (articleId: string) => `${ApiService.article}/details?articleId=${articleId}`,
  deleteArticle: `${ApiService.article}/delete`,
  addArticleToProject: `${ApiService.article}`
};
